import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledForm = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;

    .form__phone {
        margin-top: 16px;
    }

    form {
        display: flex;
        flex-direction: column;
        flex: 1 0;
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;

        form {
            display: initial;
            height: initial;
        }
    }
`
